document.addEventListener("DOMContentLoaded", function() {
    document.querySelector(".JS-close-modal").addEventListener("click", function(){
        document.querySelector(".JS-modal").classList.remove("is-active");
    });

    document.querySelector(".JS-show-hypo").addEventListener("click", function(e){
        e.preventDefault();
        document.querySelector(".JS-modal").classList.add("is-active");
    });

});